import { type ChangeHandler,type FieldError,type FieldErrors } from "react-hook-form"
import { getByPath, uniqid } from "../../tools/utils";
import { useTrads } from "../../contexts/trads/useTrads";

interface RegisterOutput {
    onChange:ChangeHandler,
    onBlur: ChangeHandler,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref:	React.Ref<any>,
    name:	string
}
interface Props {
    name:string,
    label:string,
    type?:string,
    registerOutput:RegisterOutput,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors:FieldErrors<any>,
    rest?:Record<string,string|boolean|number>
    hint?:string
}

interface PrefixProps{
    name:string,
    label:string,
    type?:string,
    registerOutput:RegisterOutput,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors:FieldErrors<any>,
    prefix:string
    rest?:Record<string,string|boolean|number>
    hint?:string
}


export function FloatingInputBootStrap({name,label,type,registerOutput,errors,rest,hint}:Props){
    const id=uniqid(name);

    const field_errors=getByPath(errors,name) as FieldError[];

    const {translate}=useTrads();
    return (
        <>
        <div className={ "form-floating " + (field_errors.length?" is-invalid":'')}>
            <input className={"form-control " + (field_errors.length?" is-invalid":'')} id={id} type={type??"text"}  
            aria-describedBy={hint?id + "Help":null}
            {...registerOutput} 
            {...rest} 
            />
            <label className="form-label" htmlFor={id}>{label}</label>
            {hint?
                <small id={id + "Help"} className="form-text text-muted">{hint}</small>
            :null}
        </div>
       {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> 
            <p key={error.message} role="alert">{translate(error.message)}</p>)
        }</div>}
        </>
    )
}


export function FloatingPrefixInputBootStrap({name,prefix,label,type,registerOutput,errors,rest,hint}:PrefixProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name)  as FieldError[];
    const {translate}=useTrads();
    return (
        <div className={"input-group " + (field_errors.length?"has-validation":'')}>
        <span className="input-group-text">{prefix}</span>
        <div className={ "form-floating " + (field_errors.length?" is-invalid":'')}>
            <input className={"form-control " + (field_errors.length?" is-invalid":'')} id={id} type={type??"text"}  
            aria-describedBy={hint?id + "Help":null}
            {...registerOutput} 
            {...rest}
            
            />
            <label className="form-label" htmlFor={id}>{label}</label>

        </div>
        {hint?
            <small id={id + "Help"} className="form-text text-muted">{hint}</small>
        :null}
        {field_errors.length>0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
        </div>
    )
}

export function FloatingPostfixInputBootStrap({name,prefix,label,type,registerOutput,errors,rest}:PrefixProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name)  as FieldError[];
    const {translate}=useTrads();

    return (
        <div className={"input-group " + (field_errors.length?"has-validation":'')}>
        
        <div className={ "form-floating " + (field_errors.length ?" is-invalid":"")}>
            <input className={"form-control " + (field_errors.length?" is-invalid":'')} id={id} type={type??"text"} 
            {...registerOutput} 
            
            {...rest}
            />
            <label className="form-label" htmlFor={id}>{label}</label>
        </div>
        <span className="input-group-text">{prefix}</span>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
        
        </div>
    )
}

export function FloatingTextareaBootstrap({name,label,registerOutput,errors,rest}:Props){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name)  as FieldError[];
    const {translate}=useTrads();
    return (
        <>
        <div className={ "form-floating " + (field_errors.length?" is-invalid":'')}>
            <textarea className={"form-control " + (field_errors.length?" is-invalid":'')} id={id}
            {...registerOutput} 
            {...rest} 
            
            ></textarea>
            <label className="form-label" htmlFor={id}>{label}</label>
        </div>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
        </>
    )
}


export function FloatinBooleanBootstrap({name,label,registerOutput,errors,rest}:Props){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads();
    return (
        <>
        <div className={ "form-check " + (field_errors.length?" is-invalid":'')}>
            <input 
            role="switch" 
            type="checkbox" 
            className={"form-check-input " + (field_errors.length?" is-invalid":'')} 
            id={id}
            {...registerOutput} 
            {...rest} 
            value="1"
            />
            <label className="form-check-label" htmlFor={id}>{label}</label>
        </div>
        {field_errors.length>0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
        </>
    )
}


export function FloatingInputGroupElemBootStrap({name,label,type,registerOutput,errors,rest}:Props){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name)  as FieldError[];
    //const {translate}=useTrads();
    return (
        <>
        <div className={ "form-floating " + (field_errors.length?" is-invalid":'')}>
            <input className={"form-control " + (field_errors.length?" is-invalid":'')} id={id} type={type??"text"}  
            {...registerOutput} 
            {...rest} 
            />
            <label className="form-label" htmlFor={id}>{label}</label>
        </div>
        {/*
        {error && <div className="invalid-feedback">{translate(error.message as string)}</div>}
         */}
        </>
    )
}